export interface GalleryFile {
  fileName: string;
  mimeType: string;
  size: string | number;
  createdAt?: Date | null;
  width?: number | null;
  height?: number | null;
  urls?: {
    download?: {
      url: string;
    };
  };
}

export function getGalleryFileSource(file: GalleryFile): string | undefined {
  return file.urls?.download?.url;
}

export function getInlineGalleryFileUrl(file: GalleryFile): string | undefined {
  const source = getGalleryFileSource(file);

  if (!source) {
    return undefined;
  }

  const url = new URL(source);

  url.searchParams.set('contentDisposition', 'inline');

  return url.toString();
}
